<h2 class="form-title">New Cancel Password Reset</h2>
<form [formGroup]="cancelPasswordResetForm" novalidate>
  <mat-form-field>
    <input matInput formControlName="emailAddress" id="emailAddress" type="email" placeholder="Email Address">

    <mat-error *ngIf="submitted && hasError('emailAddress', 'required')">{{getErrorMessage('emailAddress',
      'required')}}</mat-error>

    <mat-error *ngIf="submitted && hasError('emailAddress', 'email') && !hasError('emailAddress', 'required')">{{getErrorMessage('emailAddress',
      'email')}}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput type="text" id="verificationCode" formControlName="verificationCode" placeholder="Verification Code">

    <mat-error *ngIf="submitted && hasError('verificationCode', 'required')">{{ getErrorMessage('verificationCode',
      'required') }}</mat-error>
  </mat-form-field>

  <div class="buttons">
    <button type="submit" class="form-button" (click)="onSubmit()">Cancel Password Change</button>
  </div>
</form>